// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2ZaQC","col":"styles_col__1MNc2"};